export const getShippingPointsCount = (nearbyPoints, shippingOptions) => {
  if (!nearbyPoints.length || !shippingOptions.length) return null;
  const shippingPointsCount = {};
  shippingOptions.forEach(option => {
    if (!option.carrierCode) return;
    shippingPointsCount[option.carrierCode] = nearbyPoints.filter(nearbyPoint => option.carrierCode === nearbyPoint.point.carrierCode).length;
  });
  return shippingPointsCount;
};